import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { ApiResponse } from './../../../core/models/response-api';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientfinalCraService extends CrudService<
  ApiResponse<any>,
  number
> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }

  //  getAllListOfWorkFlowCra(){
  //   return this._http.get<ApiResponse<any>>(this._base + `/WorkFlowCra/getGeneralWorkFlowByCompanyId`),
  //   console.log("affichage", this._http.get<ApiResponse<any>>(this._base + `/WorkFlowCra/getGeneralWorkFlowByCompanyId`))
  // }
  /* LIST WORKFLOW GENERAL*/
  getAllListOfWorkFlowCra(company_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/WorkFlowTimeSheet/getGeneralWorkFlowTimeSheetByCompanyId?company_id=${company_id}`
    );
  }
  /* LIST WORKFLOW CLIENT*/
  getListWorkflowClient(data?: {
    company_id: any;
    state_workflow: any;
    per_page?: number;
    page?: number;
    sort?: number;
    type?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    let sortAttr = '';
    if (data?.sort) {
      sort = `&sort=${data.sort}`;
      sortAttr = `&sortAttribute=${data?.sortAttribute}`;
    }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/WorkFlowTimeSheet/getWorkFlowTimeSheetsByCompanyIdAndState?company_id=${data?.company_id}&state_workflow=2&per_page=${data?.per_page}&page=${data?.page}${sort}${sortAttr}`
    );
  }
  /* LIST WORKFLOW CONSULTANT*/
  getListWorkflowConsultant(data?: {
    company_id: any;
    state_workflow: any;
    per_page?: number;
    page?: number;
    sort?: number;
    type?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    let sortAttr = '';
    if (data?.sort) {
      sort = `&sort=${data.sort}`;
      sortAttr = `&sortAttribute=${data?.sortAttribute}`;
    }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/WorkFlowTimeSheet/getWorkFlowTimeSheetsByCompanyIdAndState?company_id=${data?.company_id}&state_workflow=3&per_page=${data?.per_page}&page=${data?.page}${sort}${sortAttr}`
    );
  }
  /* create WorkFlow GENERAL */
  createWorkFlowForm(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/WorkFlowTimeSheet/addWorkFlowTimeSheet`,
      data
    );
  }
  /*delete workflow */
  deleteWorkflow(id: any): Observable<any> {
    const url = `${this._base}/WorkFlowTimeSheet/deleteWorkFlowTimeSheet/${id}`;
    return this._http.delete(url);
  }
  /*update workflow */
  updateWorkflow(id: number, updatedData: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/WorkFlowTimeSheet/updateWorkFlowTimeSheet/${id}`,
      updatedData
    );
  }
  /* detail workflow*/
  getWorkflowdetail(id: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/WorkFlowTimeSheet/getWorkFlowTimeSheetById/${id}`
    );
  }
  /* detail workflow*/
  getWorkflowdetailclientconsultant(id: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/WorkFlowTimeSheet/getWorkFlowTimeSheetById/${id}`
    );
  }
  /*list consultant client final*/

  getAllconsultantclientfinal(clientFinal_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/TimeSheet/getConsultantsByClientFinal?clientFinal_id=${clientFinal_id}`
    );
  }
  getAllclientfinal(clientFinal_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/EsnClient/getListForunisseur?state=1&type[]=1&type[]=2&clientFinal_id=${clientFinal_id}`
    );
  }

  searchworkflowclient(data: any, company_id: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/WorkFlowTimeSheet/searchInWorkFlowTimeSheetsByCompanyIdAndState?company_id=${company_id}`,
      data
    );
  }
  /* add activity timesheet  */
  addTimesheet(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/TypeOfTimeSheet/add`,
      data
    );
  }
  getListtypeactivitetimesheet(data?: {
    company_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data?.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      this._base + `/TypeOfTimeSheet/getAllType?company_id=${data?.company_id}&per_page=${data?.per_page}&page=${data?.page}`
    );
  }
  /* update activity cra */
  updatetypeactivitetimesheet(idCra: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/TypeOfTimeSheet/update/${idCra}`,
      data
    );
  }
  /* delete activity cra */
  deletetypeactivitetimesheet(idCra: number) {
    return this._http.delete<ApiResponse<any>>(
      this._base + `/TypeOfTimeSheet/delete/${idCra}`
    );
  }
  /* search activity cra */
  searchtypeactivitetimesheet(data: any, company_id: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/TypeOfTimeSheet/search?company_id=${company_id}`,
      data
    );
  }
}
